import React from 'react';

/** Read-only extracted keywords box - Gemini-extracted keywords. Parses keywords_text JSON so Korean/Unicode display correctly. */
const KeywordsReadOnlyBox = ({ keywords, title = 'Extracted keywords' }) => {
  let keywordsText = '';
  if (keywords) {
    if (typeof keywords === 'string') {
      keywordsText = keywords;
    } else if (Array.isArray(keywords)) {
      keywordsText = keywords.join(', ');
    } else {
      const raw = keywords.keywords_text ?? keywords.keywords ?? '';
      if (Array.isArray(raw)) {
        keywordsText = raw.join(', ');
      } else if (typeof raw === 'string' && raw.trim().startsWith('[')) {
        try {
          const arr = JSON.parse(raw);
          keywordsText = Array.isArray(arr) ? arr.join(', ') : raw;
        } catch {
          keywordsText = raw;
        }
      } else {
        keywordsText = typeof raw === 'string' ? raw : String(raw);
      }
    }
  }
  const hasContent = keywordsText.length > 0;

  return (
    <div className="bg-card border border-border rounded-lg flex flex-col min-h-[200px] shadow-subtle-sm">
      <div className="p-2 border-b border-border flex-shrink-0">
        <h3 className="text-card-foreground text-sm font-semibold">{title}</h3>
        <p className="text-muted-foreground text-xs mt-0.5">AI Generated (Gemini)</p>
      </div>
      <div className="flex-1 bg-accent/10 rounded-b-lg p-3 border-t-0 border-border overflow-y-auto max-h-[320px]">
        {hasContent ? (
          <p className="text-sm text-foreground whitespace-pre-wrap leading-relaxed">
            {keywordsText}
          </p>
        ) : (
          <p className="text-muted-foreground text-sm italic">No keywords extracted yet</p>
        )}
      </div>
    </div>
  );
};

export default KeywordsReadOnlyBox;
